<template>
  <div>
    <p class="titleInputs">{{description}}</p>
    <div class="md:grid md:grid-cols-3 grid grid-cols-1 gap-4 mt-3">
      <div class="mb-4" style="">
        <select class="inputsForm" id="select_date_year" style="width:100%;" 
          v-model.trim="$v.yearValue.$model" :disabled="disableControls"
          :class="{'inputs-invalid-form':$v.yearValue.$error, 'inputsForm':!$v.yearValue.$invalid}">
          <option value="Año" selected hidden>Año</option>
          <option :value="item" v-for="(item, i) in yearList" :key="i">{{item}}</option>
        </select>
        <div class="content-text">
          <div v-if="$v.yearValue.$error" class="text" style="width:100%;">
            <span class="errors" v-if="!$v.yearValue.isUnique">El año es requerido</span>
          </div>
        </div>
      </div>
      <div class="mb-4" style="">
        <select class="inputsForm" :disabled="yearValue == 'Año' || disableControls" 
          id="select_date_month" style="width:100%;" 
          :class="{'inputs-invalid-form':$v.monthValue.$error, 'inputsForm':!$v.monthValue.$invalid}"
          v-model.trim="$v.monthValue.$model">
          <option value="Mes" selected hidden>Mes</option>
          <option :value="item" v-for="(item, i) in monthList" :key="i">{{item}}</option>
        </select>
        <div class="content-text">
          <div v-if="$v.monthValue.$error" class="text" style="width:100%;">
            <span class="errors" v-if="!$v.monthValue.isUnique">El mes es requerido</span>
          </div>
        </div>
      </div>
      <div class="mb-4" style="">
        <select class="inputsForm" :disabled="monthValue == 'Mes' || disableControls" 
          id="select_date_day" style="width:100%;" 
          :class="{'inputs-invalid-form':$v.dayValue.$error, 'inputsForm':!$v.dayValue.$invalid}"
          v-on:change="changeDay()" v-model.trim="$v.dayValue.$model">
          <option value="Día" selected hidden>Día</option>
          <option :value="item" v-for="(item, i) in dayList" :key="i">{{item}}</option>
        </select>
        <div class="content-text">
          <div v-if="$v.dayValue.$error" class="text" style="width:100%;">
            <span class="errors" v-if="!$v.dayValue.isUnique">El día es requerido</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {numericMonths} from '@/helpers/enums'
import {getDaysByYearAndMonth, getMonthsOfYear, getRangeOfYears, 
          createDateStringByYearMonthDay} from '@/helpers/dates'

import {required, minLength, maxLength, email, between, requiredIf} from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      monthList:[],
      dayList: [],
      yearList: [],
      dayValue: this.day,
      monthValue: this.month,
      yearValue: this.year
    }
  },
  name: 'dateComponent',
  props: {
    description: {
      type: String,
      default: ''
    },
    day: {
      type: String,
      default: 'Día'
    },
    month: {
      type: String,
      default: 'Mes'
    },
    year: {
      type: String,
      default: 'Año'
    },
    disableControls: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    yearValue: {
      required,
      isUnique(value) {
        if (value == "Año")
          return false;
        return true;
      }
    },
    monthValue: {
      required,
      isUnique(value) {
        if (value == "Mes")
          return false;
        return true;
      }
    },
    dayValue: {
      required,
      isUnique(value) {
        if (value == "Día")
          return false;
        return true;
      }
    }
  },
  watch: {
    yearValue(val) {
      this.generateMonthsAndDays(val, this.monthValue);
    },
    monthValue(val) {
      this.generateMonthsAndDays(this.yearValue, val);
    }
  },
  mounted() {
    this.getYears();
  },
  methods: {
    generateMonthsAndDays(year, month) {
      if (year != "Año") {
        this.monthList = getMonthsOfYear(year);
      }

      if (year != "Año" && month != "Mes") {
        this.dayList = getDaysByYearAndMonth(year, numericMonths[month]); 
      }

      if (this.dayValue != "Día") {
        if (!this.dayList.includes(this.dayValue)) {
          this.dayValue = "Día";
          this.emitEvent("");
        } else {
          this.emitEvent(this.getCompleteDateSelected(this.yearValue, this.monthValue, this.dayValue));
        }
      } else {
        this.emitEvent("");
      }

      if (this.monthValue != "Mes") {
        if (!this.monthList.includes(this.monthValue)) {
          this.monthValue = "Mes";
        }
      }
    },
    emitEvent(value) {
      this.$emit('get-complete-date-selected', value);
    },
    getYears() {
      this.yearList = getRangeOfYears(100);
    },
    changeDay() {
      this.emitEvent(this.getCompleteDateSelected(this.yearValue, this.monthValue, this.dayValue));
    },
    getCompleteDateSelected(year, month, day) {
      return createDateStringByYearMonthDay(year, numericMonths[month], day);
    },
    cleanFields() {
      this.dayValue = "Día";
      this.yearValue = "Año";
      this.monthValue = "Mes";
      this.$v.$reset()
    },
    setDate(day, month, year) {
      this.yearValue = year;
      this.monthValue = month;
      this.dayValue = day;
    }
  }
}
</script>